import { SUPPRESSION_SCOPE_LABELS, SuppressionScope } from '~/services/AriAnomaliesService';

/**
 * What a suppression did, in terms that are true for every case it touched.
 *
 * It names the scope, the duration and how many cases fell silent, and deliberately names no
 * case and no status. 'This kind of alert, everywhere' reads like a single dismissal right up
 * until someone notices the queue lost forty cases, so the count is the part that stops a
 * wide suppression looking narrow.
 *
 * No case id, because a suppression only moves cases that are still pending or acknowledged —
 * so on a case that was already resolved, 'ARI-123 suppressed' would be false. No expiry
 * either: the user chose a duration, and echoing back a computed timestamp invites them to
 * check arithmetic instead of reading the sentence.
 */
export function suppressionMessage(
  days: number,
  scope: SuppressionScope,
  /** absent when the response predates the count, rather than meaning none were silenced */
  casesSuppressed?: number,
): string {
  const base = `Suppressed for ${days} day(s) — ${SUPPRESSION_SCOPE_LABELS[scope]}`;

  if (casesSuppressed === undefined || casesSuppressed === 1) {
    return base;
  }
  if (casesSuppressed === 0) {
    return `${base} · no open cases to silence, but new ones will be`;
  }
  return `${base} · ${casesSuppressed.toLocaleString()} cases silenced`;
}
